export default __webpack_public_path__ + "static/media/spa-image-10.f17ddacc.jpg";